import * as React from "react";
import {FBFieldBase, FBFieldBaseProps, FBFieldBaseState} from "./FBFieldBase";
import {SubFieldPrice} from "./SubComponents/SubFieldPrice";

import {FBFieldWithPriceBaseModel} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Model";
import {
    FBFieldWithPriceBase,
    FBFieldWithPriceBaseProps,
    FBFieldWithPriceBaseState
} from "FormBuilder/Fields/Core/FBFieldWithPriceBase";

export abstract class FBMultipleOptionsBase<p extends FBMultipleOptionsBaseProps=FBMultipleOptionsBaseProps,s extends FBMultipleOptionsBaseState=FBMultipleOptionsBaseState> extends FBFieldWithPriceBase<p, s> {


    constructor(props: p) {
        super(props);

    }




}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
export interface FBMultipleOptionsBaseProps  extends FBFieldWithPriceBaseProps{
    Model:FBFieldWithPriceBaseModel;
}

export interface FBMultipleOptionsBaseState extends FBFieldWithPriceBaseState{

}

//#endregion "My Region"